import { render, staticRenderFns } from "./AdminEventTable.vue?vue&type=template&id=2c550807&scoped=true"
import script from "./AdminEventTable.vue?vue&type=script&lang=ts"
export * from "./AdminEventTable.vue?vue&type=script&lang=ts"
import style0 from "./AdminEventTable.vue?vue&type=style&index=0&id=2c550807&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c550807",
  null
  
)

export default component.exports